import { Group, Text } from '@common/ui'
import React, { ReactNode } from 'react'
import { com } from '@eidu/web'
import Field = com.eidu.entity.field.Field

export type EntityFieldDisplayRowProps = {
  field: Field
  children?: ReactNode
}

const EntityFieldDisplayRow = ({ field, children }: EntityFieldDisplayRowProps) => (
  <Group align="flex-start" gap="md" wrap="nowrap" py="md" style={{ borderBottom: '1px solid #eee' }}>
    <Text fw={600} size="sm" w={220} style={{ flexShrink: 0 }}>
      {field.name}
    </Text>
    {children}
  </Group>
)

export default EntityFieldDisplayRow
